<!-- RotationSkipSlots.vue -->

<template>
  <div>
    <b-row v-if="loading" align-h="center">
      <SmallSpinner :size="50" centered />
    </b-row>

    <b-row
      v-for="(deliverySlot, key) in skipAllDeliverySlots"
      v-if="!loading"
      :key="key"
      class="w-100 mt-3"
    >
      <b-col cols="12" sm="12" md="5" lg="7" class="mb-3">
        <span>
          {{ showSlotTime(key) }}
          <span v-if="isSkipped(deliverySlot)">(skipped)</span>
          <b-badge
            v-if="!isSkipped(deliverySlot)"
            :variant="getStatusVariant(deliverySlot)"
            class="ml-2"
          >
            {{ getStatusLabel(deliverySlot) }}
          </b-badge>
        </span>
      </b-col>

      <b-col class="rotation-buttons" cols="12" sm="12" md="7" lg="5">
        <b-row cols="12" sm="12" md="4" lg="4" class="rotation-button">
          <b-button
            class="btn btn-secondary ml-2"
            :disabled="
              !deliverySlot.is_ready &&
                !deliverySlot.has_selection &&
                deliverySlot.status !== 'ordered'
            "
            @click="
              deliverySlot.scheduled || deliverySlot.has_selection
                ? viewMealsSelectionForSlot(deliverySlot)
                : selectMealsForSlot(key)
            "
          >
            <span
              v-if="
                deliverySlot.scheduled ||
                  deliverySlot.has_selection ||
                  deliverySlot.status === 'ordered'
              "
            >
              VIEW MEALS
            </span>
            <span
              v-else-if="
                deliverySlot.is_ready || deliverySlot.status === 'ready'
              "
            >
              SELECT MEALS
            </span>
            <span v-else> PENDING </span>
          </b-button>
        </b-row>

        <b-row cols="12" sm="12" md="4" lg="4" class="rotation-button">
          <b-button
            class="ml-2 skip-button"
            :class="isSkipped(deliverySlot) ? 'disabled' : ''"
            :disabled="isSkipped(deliverySlot)"
            @click="
              isSkipped(deliverySlot)
                ? openDeleteModal(key)
                : openSkipModal(key)
            "
          >
            <span>{{ isSkipped(deliverySlot) ? 'Unskip' : 'Skip' }}</span>
          </b-button>
        </b-row>
      </b-col>
    </b-row>

    <!-- <div v-else class="mt-3">
        No slots available for the selected date.
    </div> -->

    <b-modal
      size="medium"
      :visible="skipSlot !== null"
      title="Skip delivery for this date?"
      ok-title="Skip"
      @hidden="skipSlot = null"
      @ok="submitSkippedSlot(skipSlot)"
    >
      <p>
        <b>NOTICE:</b> Skip slot for this date {{ showSlotTime(skipSlot) }}?
      </p>
    </b-modal>

    <b-modal
      :visible="deleteSlot !== null"
      title="Delete this skipped slot delivery for this date?"
      ok-title="Delete"
      @hidden="deleteSlot = null"
      @ok="deleteSkippedSlot(deleteSlot)"
    >
      <p>
        <b>NOTICE:</b> Skip slot for this date {{ showSlotTime(deleteSlot) }}?
      </p>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';

import SmallSpinner from '@/common/SmallSpinner.vue';

import { mapGetters } from 'vuex';

import {
  deleteSkippedSlot,
  getAllSkipDeliverySlots,
  getSkipDeliverySlots,
  submitSkippedSlot,
} from './rotating-subscription-service';
import { axios } from '^/axios';

export default {
  name: 'RotationSkipSlots',
  components: {
    SmallSpinner,
  },
  props: {
    skipDelivery: { type: Boolean, default: false },
    subscription: { type: Object, default: [] },
  },
  data: () => {
    return {
      deliveryOptions: [
        { text: 'Skip delivery', value: false },
        { text: 'Select day', value: true },
      ],
      subscription_data: Object,

      skipAllDeliverySlots: [],
      skipDeliverySlots: [],
      loading: false,
      skipSlotLoading: false,

      skipSlot: null,
      deleteSlot: null,

      selectedDate: '',
      slotDays: {},
    };
  },
  async created() {
    await this.fetchSkipSlotsData();
  },
  computed: {
    ...mapGetters(['vendor', 'region', 'user']),
    getSelectedDaySlots() {
      return this.slotDays[this.selectedDate];
    },
  },

  mounted() {},
  methods: {
    isSkipped(deliverySlot) {
      return deliverySlot.isScheduled && deliverySlot.isScheduled === true;
    },
    getStatusVariant(deliverySlot) {
      if (deliverySlot.has_selection || deliverySlot.status === 'ordered') {
        return 'success';
      } else if (deliverySlot.is_ready || deliverySlot.status === 'ready') {
        return 'primary';
      } else {
        return 'secondary';
      }
    },
    getStatusLabel(deliverySlot) {
      if (deliverySlot.has_selection || deliverySlot.status === 'ordered') {
        return 'Selected';
      } else if (deliverySlot.is_ready || deliverySlot.status === 'ready') {
        return 'Ready';
      } else {
        return 'Pending Menu';
      }
    },
    async viewMealsSelectionForSlot(deliverSlot) {
      const response = await axios.get(
        `/subscription/${this.subscription.uuid}/order/${deliverSlot.uuid}`
      );
      this.$emit('view-meals-selection-for-slot', response);
    },
    selectMealsForSlot(slotDateTime) {
      // Extract the day of week (0-6, Sunday to Saturday) and time from the slotDateTime
      const dayOfWeek = moment(slotDateTime).day();
      const timeString = moment(slotDateTime).format('HH:mm:ss');

      // Get the subscription object and rotating subscription details
      const subscriptionObj = {
        ...this.subscription,
        rotatingSubscription: this.subscription.order.rotating_subscription,
      };

      // Emit an event to show the meal selection modal with the appropriate parameters
      this.$root.$emit(
        'show-meal-selection',
        subscriptionObj,
        dayOfWeek,
        timeString
      );
    },
    selectSlot(slotDateTime) {
      this.$emit('selectSlot', slotDateTime);
    },

    async fetchSkipSlotsData() {
      this.skipAllDeliverySlots = [];
      try {
        this.loading = true;
        const allSlotsResults = await getAllSkipDeliverySlots(
          this.subscription.uuid
        );

        this.skipDeliverySlots = await getSkipDeliverySlots(
          this.subscription.uuid
        );

        this.skipAllDeliverySlots = Object.entries(allSlotsResults).reduce(
          (acc, [key, slot]) => {
            if (!key) return acc;

            let slotScheduled = moment(key).utc().format('YYYY-MM-DD HH:mm:ss');

            const isScheduled = this.skipDeliverySlots.some(
              (deliverySlot) => deliverySlot.scheduled === slotScheduled
            );

            // Handle the new slot structure which may include status information
            let slotData = {
              isScheduled: isScheduled,
              has_selection: false,
            };

            // Check if slot is the new format (object with status)
            if (slot && typeof slot === 'object') {
              // If slot has an order property, then it's an ordered slot
              if (slot.order) {
                slotData = {
                  ...slotData,
                  ...slot.order,
                  status: slot.status || 'ordered',
                  uuid: slot.order.uuid, // Keep the uuid for existing references
                };
              } else {
                // This is a future slot with status information
                slotData = {
                  ...slotData,
                  ...slot,
                  // For 'ready' status slots, set has_selection to false but allow meal selection
                  // For 'pending menu' status slots, also set has_selection to false but indicate not ready
                  has_selection: false,
                  is_ready: slot.status === 'ready',
                };
              }
            } else {
              // If slot is still in the old format (null or direct object)
              slotData.uuid = slot ? slot.uuid : null;
              slotData.has_selection = slot ? true : false;
            }

            acc[key] = slotData;
            return acc;
          },
          {}
        );
      } catch (e) {
        console.error('Error in skipDelivery watcher:', e.message);
        await this.$store.dispatch('alertError', ['danger', e.message]);
      } finally {
        this.loading = false;
      }
    },

    async openSkipModal(slot) {
      this.skipSlot = slot;
    },
    async submitSkippedSlot(slot) {
      const slotDateUtc = moment(slot).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

      try {
        this.skipSlotLoading = true;
        const response = await submitSkippedSlot(
          this.subscription.uuid,
          slotDateUtc
        );
      } catch (e) {
        await this.$store.dispatch('alertError', ['danger', e.message]);
      } finally {
        this.skipSlotLoading = false;
        this.skipSlot = null;

        await this.fetchSkipSlotsData();
      }
    },

    async openDeleteModal(slot) {
      this.deleteSlot = slot;
    },
    async deleteSkippedSlot(slot) {
      const slotDateUtc = moment(slot).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

      try {
        this.skipSlotLoading = true;
        const response = await deleteSkippedSlot(
          this.subscription.uuid,
          slotDateUtc
        );
      } catch (e) {
        await this.$store.dispatch('alertError', ['danger', e.message]);
      } finally {
        this.skipSlotLoading = false;
        this.deleteSlot = null;

        await this.fetchSkipSlotsData();
      }
    },

    showSlotTime(slotDate) {
      return moment(slotDate).tz(this.region.timezone).format('MMMM Do h:mm a');
    },

    dateDisabled(ymd, date) {
      // Return `true` if the date should be disabled
      return !Object.hasOwn(this.slotDays, moment(date).format('YYYY-MM-DD'));
    },

    getSlotDays() {
      this.slotDays = {};
      Object.keys(this.skipAllDeliverySlots).map((slot) => {
        const slotDayScheduled = moment(slot).utc().format('YYYY-MM-DD');
        const slotTimeScheduled = moment(slot).utc().format('HH:mm:ss');

        let slotScheduled = moment(slot).utc().format('YYYY-MM-DD HH:mm:ss');

        const isScheduled = this.skipDeliverySlots.some(
          (deliverySlot) => deliverySlot.scheduled === slotScheduled
        );

        if (!this.slotDays[slotDayScheduled])
          this.slotDays[slotDayScheduled] = [];
        this.slotDays[slotDayScheduled].push({
          time: slotTimeScheduled,
          isScheduled: isScheduled,
          formattedDate: moment(slot)
            .tz(this.region.timezone)
            .format('MMMM Do h:mm a'),
          neededDateTime: slot,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables.module';

@include inputs;

@include buttons;

.w-100 {
  display: flex;
  justify-content: space-between;
}

.rotation-buttons {
  display: flex;
  width: 31%;
  justify-content: end;
}

.rotation-button {
  margin-right: 10px;
}

@media #{$belowMd} {
  .rotation-buttons {
    flex-direction: column;
  }
  .rotation-buttons .btn {
    width: 100%;
    margin-bottom: 10px;
  }
}

.skip-button {
  min-width: 75px;
}
</style>
